import React, { useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './TeamPowerIndicator.css';

const cx = classnames.bind(styles);

const ITEMS = [
    'Excellent progress',
    'Great improvement',
    'Impressive growth',
    'Fantastic increase',
    'Good'
];

const shuffleList = array => [...array].sort(() => 0.5 - Math.random());

function TeamPowerIndicator({
    className,
    value,
    height,
    withInitAnimate
}) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });
    const valueRef = useRef(value);

    const [isVisibleName, setIsVisibleName] = useState(false);

    useEffect(() => {
        if (value > 0 && value >= Number(valueRef.current) && withInitAnimate) {
            setIsVisibleName(true);
        } else {
            setIsVisibleName(false);
        }

        valueRef.current = value;
    }, [value]);

    const itemName = useMemo(() => shuffleList(ITEMS)[0], [value]);

    const endAnimation = () => {
        setIsVisibleName(false);
    };

    return (
        <div className={classes}>
            <p className={styles.title}>Team power</p>
            <div className={styles.indicator}>
                <div
                    className={styles.activeBar}
                    style={{width: `${value}%`, height}}
                />
            </div>
            <p
                className={cx('description', {visible: isVisibleName})}
                key={value}
                onAnimationEnd={endAnimation}
            >
                {itemName}!
            </p>
        </div>
    );
};

TeamPowerIndicator.propTypes = {
    className: PropTypes.string,
    value: PropTypes.number.isRequired,
    height: PropTypes.number,
    withInitAnimate: PropTypes.bool
};

TeamPowerIndicator.defaultProps = {
    className: '',
    height: 4,
    withInitAnimate: true
};

export {
    TeamPowerIndicator
}
